import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { MessageBox, Spacing } from '@reservamos/elements';
import { useWhitelabelFeatures } from 'hooks/whitelabel/useWhitelabelFeatures';
import LoyaltyWidget from 'components/LoyaltyWidget/LoyaltyWidget';
import useWhitelabelEnvs from 'hooks/whitelabel/useWhitelabelEnvs';
import useLoyaltyPrograms from '../../loyalty/context/useLoyaltyPrograms';
import './LoyaltyMessagesLink';

const CostaPassMessage = ({ show }) => {
  const {
    costaPass: { config },
  } = useLoyaltyPrograms();
  const features = useWhitelabelFeatures();
  const { t } = useTranslation('loyalty');
  const { travelpassLoyaltyConfig } = useWhitelabelEnvs();
  const prefix = travelpassLoyaltyConfig?.prefix || 'costapass';

  if (!show || !features.COSTAPASS_ENABLED) return null;

  const message = t('receive_costapass_benefits', { context: prefix });
  const cta = t('sign_cta', { context: prefix });

  return (
    <div className="dotersMessagesContainer">
      <MessageBox roundCorners borderColor="primary" widthFull>
        <Spacing justifyContent="space-between">
          <Spacing size="S" alignItems="baseline" justifyContent="flex-start">
            <i className={`${prefix}-logo`} />
            <div className="primaryfont">
              <LoyaltyWidget
                linkText={message}
                hideIcon
                id={`${prefix}LoyaltyMessages`}
                variant="link-home"
                ctaText={cta}
                visible
                extraConfig={config}
              />
            </div>
          </Spacing>
        </Spacing>
      </MessageBox>
    </div>
  );
};

CostaPassMessage.propTypes = {
  show: PropTypes.bool,
};

export default CostaPassMessage;
